import { NgModule } from '@angular/core';
import { CheckboxComponent } from './checkbox';

@NgModule({
  declarations: [CheckboxComponent],
  exports: [CheckboxComponent],
})
export class CheckboxModule {}
